import { render, staticRenderFns } from "./SendVerification.vue?vue&type=template&id=b0ec9aca&scoped=true"
import script from "./SendVerification.vue?vue&type=script&lang=ts"
export * from "./SendVerification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ec9aca",
  null
  
)

export default component.exports